import React, { useEffect, useState } from "react";
import "./Quotationcard.css";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import ModalComponent from "../../../Components/Features/ModalComponent";
import { Images, careSupremeBenefits, productDetails } from "../../../Data/Benifits";
import {
  Tooltip,
  LinearProgress,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  updatedQuotationResult,
  updatePremiumPostObject,
  setSelectedProvider,
  storeQuote
} from "../../../../Redux/Health/action";
import { useNavigate } from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { fetchQuotationDataHelper,processQuoteData } from "../../../utils/quotationHelper";

const RelianceInfinityCard = ({ collectData }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState(false);
  const [productFeatures, setProductFeatures] = useState([]);
  const [premium, setPremium] = useState(null);
  const [image, setImage] = useState(null);
  const selfGender = useSelector((state) => state?.healthReducer?.proposerGender)


  const navigate = useNavigate();
  const dispatch = useDispatch();
  const premiumPostBody = useSelector(
    (state) => state?.healthReducer?.premiumPostObject
  );
  const [postBody, setPostBody] = useState(premiumPostBody);

  const handleChange = (e) => {
    collectData(e.target.checked, quote);
  };
  useEffect(() => {
    fetchQuotationDataHelper({
      postBody,
      provider: "reliance", 
      extraParams: {
        selfGender,                 
      },
      selectedCoverage: premiumPostBody?.selectedCoverage,
      setLoading,
      setQuote,
      productname:"Reliance Infinity"
     
    });
  }, [postBody,premiumPostBody?.selectedCoverage,selfGender]);

  useEffect(() => {
    setPostBody(premiumPostBody);
  }, [premiumPostBody]);
  const handleModal = () => {
    setModalOpen(!modalOpen);
  };

  useEffect(() => {
    if (quote) {
      processQuoteData({
        quote,
        setProductFeatures,
        setImage,
        setPremium,
        productDetails,
        Images,
        dispatch,
        storeQuote,
      });
    }
  }, [quote,dispatch]);
  
  const handleNavigate = (quote) => {
    let provider = quote.provider;
    let code = quote.code;
    const updatedPostBody = {
      ...postBody,
      provider: provider,
      abacusId: code,
    };
    navigate("/health/proposalform");
    dispatch(updatedQuotationResult(quote));
    dispatch(setSelectedProvider(provider));

    dispatch(updatePremiumPostObject(updatedPostBody));
  };

 const handleCheckboxChange = (name, value) => {
  let updatedPostBody = { ...postBody };

  // Normalize value (checkbox sends boolean, select sends string)
  const isBoolean = typeof value === "boolean";

  if (name === "SelectedDeductibleInfinity") {
    updatedPostBody[name] = isBoolean ? value : value !== "";
    updatedPostBody["Deductible"] = updatedPostBody[name] ? "10000" : "";
  } else if (name === "RoomRentInfinity") {
    updatedPostBody[name] = isBoolean ? value : value !== "";
    updatedPostBody["roomRentType"] = updatedPostBody[name]
      ? "Twin Sharing"
      : "";
  } else if (name === "SmartProtector") {
    updatedPostBody[name] = isBoolean ? value : value !== "";
    updatedPostBody["SuperChargerOption"] = updatedPostBody[name]
      ? "Option 1"
      : "";
  } else if (name === "OpdCover") {
    updatedPostBody[name] = isBoolean ? value : value !== "";
    if (updatedPostBody[name]) {
      updatedPostBody["Plan"] = "Plan A";
      updatedPostBody["OpdLimit"] = "10000";
    } else {
      updatedPostBody["Plan"] = "";
      updatedPostBody["OpdLimit"] = "";
    }
  } else if (name === "Plan") {
    updatedPostBody[name] = value;
    if (value === "Plan A") {
      updatedPostBody["OpdLimit"] = "10000";
    } else if (value === "Plan B") {
      updatedPostBody["OpdLimit"] = "25000";
    } else {
      updatedPostBody["OpdLimit"] = "";
    }
  } else if (name === "MotherCare") {
    updatedPostBody[name] = isBoolean ? value : value !== "";
    if (updatedPostBody[name]) {
      updatedPostBody["MotherSumInsured"] = "100000";
      updatedPostBody["MotherWaitingPeriod"] = "12 Months";
    }else{
            updatedPostBody["MotherSumInsured"] = "";
      updatedPostBody["MotherWaitingPeriod"] = "";
    }
  }else if(name==="PEDInfinity"){
    updatedPostBody[name] = isBoolean ? value : value !== "";
    if(updatedPostBody[name]){
      updatedPostBody["PEDRangeInfinity"]="12 Months"
    }else{
      updatedPostBody["PEDRangeInfinity"]=""
    }

  } else {
    updatedPostBody[name] = value;
  }

  setPostBody(updatedPostBody);
};
 console.log(postBody,"jhjhkjhkj")

  return (
    <>
      <ModalComponent
        open={modalOpen}
        handleClose={handleModal}
        quote={quote}
        features={careSupremeBenefits}
      />
      {loading ? (
        <LinearProgress />
      ) :(  
      
      (quote && quote?.premiumWithGST && quote?.premiumWithGST !=="0")&& (
        <div className="health_quotation_main_card  mb_25 ">
          <div className="mt-2">
            <input
              className="form-check-input"
              onChange={(e) => handleChange(e)}
              type="checkbox"
              style={{
                fontSize: "25px",
                marginLeft: "10px",
                border: "1px solid",
              }}
            />
          </div>
          <div className="d_flex quotation_upr_div">
            <div className="logo_container">
              <img src={image} alt="CARE HEALTH" className="logo_box" />
            </div>

            <div className="quotation_content">
              <div className="content_box_cs">
                <div className="plane_name plan_details">
                  <div className="title_pa">{quote?.productName}</div>
                  <div className="suminsured_text">
                    Sum Insured : ₹{quote?.sumInsured}
                  </div>
                  <b>{quote?.term || quote?.tenure} year policy</b>
                </div>

                <div className="plan_feature plan_details">
                  <div
                    className="health_check_compare"
                    style={{ marginRight: "30px" }}
                  >
                    <ul className="features_list">
                      {productFeatures?.slice(0, 4)?.map((item, i) => (
                        <li key={i} className="font-12">
                          <Tooltip title={item.benefit} placement="right-start">
                            <HealthAndSafetyIcon
                              fontSize="small"
                              style={{ marginRight: "5px", color: "#03a9f4" }}
                            />
                            <span className="font-blue">{item.feature}</span>
                          </Tooltip>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="health_check_compare">
                    <ul className="features_list">
                      {productFeatures?.slice(4, 8)?.map((item, i) => (
                        <li key={i} className="font-12">
                          <Tooltip title={item.benefit} placement="right-start">
                            <HealthAndSafetyIcon
                              fontSize="small"
                              style={{ marginRight: "5px", color: "#03a9f4" }}
                            />
                            <span className="font-blue">{item.feature}</span>
                          </Tooltip>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div onClick={() => handleNavigate(quote)} className="text_right hal_buy_btn_btn plan_details buy_btn">
                  {/* <a onClick={() => handleNavigate(quote)} className="buy_btn"> */}
                    <Tooltip title="Buy Plan" placement="bottom">
                      <span>
                        <i className="fa-solid fa-indian-rupee-sign mr_5"></i>₹{" "}
                        {premium}
                      </span>
                    </Tooltip>
                    <p>*Including GST</p>
                    <small>BUY NOW</small>
                  {/* </a> */}
                </div>
              </div>
            </div>
          </div>

          <div className="d_flex quotation_bottom_div">
            <button onClick={handleModal} className="features_btn">
              View Features <ChevronRightIcon />
            </button>
          </div>

          <div className="add_addon_div">
            <div className="d_flex addons_flex_container">
              <div className="health_addons_input_box">
                <label>
                  <input
                    checked={Number(postBody?.LimitlessCover)}
                    type="checkbox"
                    name="LimitlessCover"
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.checked)
                    }
                  />
                  <span>Limitless Cover</span>
                </label>
              </div>

              <div className="health_addons_input_box">
                <label>
                  <input
                    checked={Number(postBody?.SmartProtector)}
                    type="checkbox"
                    name="SmartProtector"
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.checked)
                    }
                  />
                  <span>Smart Protector</span>
                </label>

                {postBody?.SmartProtector === true && (
                  <>
                    <select
                      name="SuperChargerOption"
                      value={postBody?.SuperChargerOption}
                      onChange={(e) => handleCheckboxChange(e.target.name, e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="Option 1">Option 1</option>
                      <option value="Option 2">Option 2</option>


                    </select>

                  </>
                )}

              </div>

              <div className="health_addons_input_box">
                <label>
                  <input
                    checked={Number(postBody?.OpdCover)}
                    type="checkbox"
                    name="OpdCover"
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.checked)
                    }
                  />
                  <span>OPD Cover</span>
                </label>

                {postBody?.OpdCover === true && (
                  <>
                    <select
                      name="Plan"
                      value={postBody?.Plan}
                      onChange={(e) => handleCheckboxChange(e.target.name, e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="Plan A">Plan A</option>
                      <option value="Plan B">Plan B</option>


                    </select>

                    {postBody?.Plan === "Plan A" && (
                      <select
                        name="OpdLimit"
                        value={postBody?.OpdLimit}
                        onChange={(e) => handleCheckboxChange(e.target.name, e.target.value)}
                      >
                        <option value="">Select OPD Limit</option>
                        <option value="10000">10,000</option>
                        <option value="15000">15,000</option>
                        <option value="20000">20,000</option>
                      </select>
                    )}

                    {postBody?.Plan === "Plan B" && (
                      <select
                        name="OpdLimit"
                        value={postBody?.OpdLimit}
                        onChange={(e) => handleCheckboxChange(e.target.name, e.target.value)}
                      >
                        <option value="">Select OPD Limit</option>
                        <option value="25000">25,000</option>
                        <option value="30000">30,000</option>
                        <option value="35000">35,000</option>
                        <option value="40000">40,000</option>
                        <option value="45000">45,000</option>
                        <option value="50000">50,000</option>
                      </select>
                    )}

                  </>
                )}

              </div>


              <div className="health_addons_input_box">
                <label>
                  <input
                    checked={Number(postBody?.MedicalEquipmentCover)}
                    type="checkbox"
                    name="MedicalEquipmentCover"
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.checked)
                    }
                  />
                  <span>Medical Equipment Cover</span>
                </label>
              </div>


              <div className="health_addons_input_box">
                <label>
                  <input
                    checked={Number(postBody?.DoubleCover)}
                    type="checkbox"
                    name="DoubleCover"
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.checked)
                    }
                  />
                  <span>Double Cover</span>
                </label>
              </div>

              <div className="health_addons_input_box">
                <label>
                  <input
                    checked={Number(postBody?.HomeCareTreatment)}
                    type="checkbox"
                    name="HomeCareTreatment"
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.checked)
                    }
                  />
                  <span>Home Care Treatment</span>
                </label>
              </div>


              <div className="health_addons_input_box">
                <label>
                  <input
                    checked={Number(postBody?.ReductionInWaitingPeriod)}
                    type="checkbox"
                    name="ReductionInWaitingPeriod"
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.checked)
                    }
                  />
                  <span>Reduction in Specific Illness Waiting Period</span>
                </label>
              </div>
              {premiumPostBody.tenure === "3 Year" && (
                <div className="health_addons_input_box">
                  <label>
                    <input
                      checked={Number(postBody?.MotherCare)}
                      type="checkbox"
                      name="MotherCare"
                      onChange={(e) =>
                        handleCheckboxChange(e.target.name, e.target.checked)
                      }
                    />
                    <span>Mother and Child Care</span>
                  </label>

                  {postBody?.MotherCare === true && (
                    <>
                      <select
                        name="MotherSumInsured"
                        value={postBody?.MotherSumInsured}
                        onChange={(e) => handleCheckboxChange(e.target.name, e.target.value)}
                      >
                        <option value="0">0</option>
                        <option value="100000">100000</option>
                        <option value="200000">200000</option>


                      </select>

                      <select
                        name="MotherWaitingPeriod"
                        value={postBody?.MotherWaitingPeriod}
                        onChange={(e) => handleCheckboxChange(e.target.name, e.target.value)}
                      >
                        <option value="0">0</option>
                        <option value="12 Months">12 Months</option>
                        <option value="24 Months">24 Months</option>


                      </select>

                    </>
                  )}


                </div>
              )}






              <div
                className="health_addons_input_box"
                style={{ marginBottom: "20px" }}
              >
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    fontSize: "8px",
                    fontWeight: "500",
                  }}
                >
                  <input
                    type="checkbox"
                    name="RoomRentInfinity"
                    checked={Number(postBody?.RoomRentInfinity)}
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.checked)
                    }
                    style={{ transform: "scale(1.2)", cursor: "pointer" }}
                  />
                  <span>Reduction in Room Rent</span>
                </label>

                {postBody?.RoomRentInfinity && (
                  <select
                    name="roomRentType"
                    value={postBody?.roomRentType}
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.value)
                    }
                  >
                    <option value="">Select</option>
                       <option value="Twin Sharing">Twin sharing</option>
                    <option value="Single Private AC Room">Single Private AC Room</option>

                  </select>
                )}
              </div>



              <div
                className="health_addons_input_box"
                style={{ marginBottom: "20px" }}
              >
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    fontSize: "8px",
                    fontWeight: "500",
                  }}
                >
                  <input
                    type="checkbox"
                    name="PEDInfinity"
                    checked={Number(postBody?.PEDInfinity)}
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.checked)
                    }
                    style={{ transform: "scale(1.2)", cursor: "pointer" }}
                  />
                  <span>Change in Pre-Existing Waiting Period </span>
                </label>

                {postBody?.PEDInfinity && (
                  <select
                    name="PEDRangeInfinity"
                    value={postBody?.PEDRangeInfinity}
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.value)
                    }
                  >
                    <option value="">Select</option>
                       <option value="12 Months">12 Months</option>
                    <option value="24 Months">24 Months</option>

                  </select>
                )}
              </div>

              <div className="health_addons_input_box">
                <label>
                  <input
                    type="checkbox"
                    name="SelectedDeductibleInfinity"
                    checked={Number(postBody?.SelectedDeductibleInfinity)}
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.checked)
                    }
                  />

                  <span>Voluntary Aggregate Deductible</span>
                </label>
                {postBody?.SelectedDeductibleInfinity === true && (
                  <select
                    name="Deductible"
                    value={postBody?.Deductible}
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.value)
                    }
                  >
                    <option value="0">0</option>
                    <option value="10000">10000</option>
                    <option value="25000">25000</option>
                    <option value="50000">50000</option>
                    <option value="100000"> 100000</option>

                  </select>
                )}
              </div>
            </div>
          </div>
        </div>
      ) 
    )}
    </>
  );
};

export default RelianceInfinityCard;
